import React from "react";
import GlobalHeader from "../../components/header";
import Footer from "../../components/footer";
import { Box, Button, Stack, Typography } from "@mui/material";
import CheckIcon from "../../images/check-mark.svg";
import { Link } from "react-router-dom";

function VerifiedAccount() {
  return (
    <>
      <GlobalHeader />
      <Stack
        sx={{
          height: "calc(100vh - 100px)",
          width: { xs: "100vw", sm: "90vw", md: "85vw", lg: "65vw" },
          pb: 4,
          backgroundColor: "white",
          marginInline: "auto",
          placeContent: "center",
        }}
      >
        <Stack>
          <Box
            sx={{
              width: { xs: 100, sm: 120, lg: 110 },
              textAlign: "center",
              marginInline: "auto",
              mb: 2,
            }}
          >
            <img src={CheckIcon} style={{ width: "100%", height: "100%" }} />
          </Box>
          <Typography
            fontSize="large"
            sx={{
              fontWeight: "normal",
              textAlign: "center",
              width: "50%",
              marginInline: "auto",
              mb: 4,
            }}
          >
            ¡Genial! Tu cuenta ha sido verificada, ya puedes iniciar sesión.
          </Typography>
          <Button
            variant="contained"
            LinkComponent={Link}
            to={"/login"}
            sx={{
              width: "fit-content",
              px: 4,
              marginInline: "auto",
              color: "white",
              textTransform: "capitalize",
            }}
          >
            Iniciar Sesión
          </Button>
        </Stack>
      </Stack>
      <Footer />
    </>
  );
}

export default VerifiedAccount;
